// @flow
import React, { PureComponent } from 'react';
import { chunk } from 'lodash';

import { dynamicClassName } from 'utils/dynamicClassName';

import type { RencontreType, RencontreJoueurType } from 'types/Rencontre';

export type StateProps = {
  rencontre: ?RencontreType;
  placeholder: string,
};

type Props = StateProps;

type State = {
  open: boolean,
  isPlayerHovered: boolean,
  playerHovered: string,
  position: Object,
};

class RencontreTeam extends PureComponent<Props, State> {
  state: State = {
    isPlayerHovered: false,
    playerHovered: '',
    open: false,
    position: {}
  };

  onPlayerVisiteurHoverOn = (e: SyntheticInputEvent<EventTarget>, ordre: number) => {
    return false;
  };

  onPlayerHoverOn = (e: SyntheticInputEvent<EventTarget>, ordre: number) => {
    const position = e.target.getBoundingClientRect();
    const playerHovered = e.target.dataset.player;
    const { bottom, left, right, top } = position;

    document.addEventListener('touchstart', this.onPlayerHoverOut);

    if (playerHovered) {
      this.setState({ isPlayerHovered : true, playerHovered, position : { bottom, left, right, top } });
    }
  };

  onPlayerVisiteurHoverOut = () => {
  };

  onPlayerHoverOut = () => {
    document.removeEventListener('touchstart', this.onPlayerHoverOut);
    this.setState({ isPlayerHovered : false });
  };

  _renderColumn = (joueurs: RencontreJoueurType[], isLocalTeam?: boolean = true): React$Element<'li'>[] | null => {
    const { rencontre } = this.props;

    if (!rencontre) {
      return null;
    }


    const cartonJaune = rencontre.actions.find((action) => action.type === 'carton jaune');
    const cartonRouge = rencontre.actions.find((action) => action.type === 'carton rouge');
    const remplacement = rencontre.actions.find((action) => action.type === 'remplacement');

    return joueurs.map((joueur: RencontreJoueurType, index: number): React$Element<'li'> => {
      const { nom, prenom, idPersonne, position, estCapitaine, id } = joueur;
      const spanClassName = dynamicClassName('');

      if (estCapitaine) {
        spanClassName.add('captain');
      }

      if (
        cartonJaune &&
        cartonJaune.localActions.find((cart) => cart.joueur ? cart.joueur.id === id : false)
      ) {
        spanClassName.add('yellow-card');
      }

      if (
        cartonRouge &&
        cartonRouge.localActions.find((cart) => cart.joueur ? cart.joueur.id === id : false)
      ) {
        spanClassName.add('red-card');
      }

      const remplacementJoueur = remplacement &&
        remplacement.localActions.find((cart) => cart.joueur ? cart.joueur.id === id : false);

      if (remplacementJoueur) {
        spanClassName.add('substitution');
      }

      return (
        <li
          key={`${idPersonne}_${index}`}
          data-num={position}>
          <p>
            {/* eslint-disable-next-line */}
            {/*<a
              onMouseEnter={isLocalTeam ? this.onPlayerHoverOn : this.onPlayerVisiteurHoverOn}
            onMouseLeave={isLocalTeam ? this.onPlayerHoverOut : this.onPlayerVisiteurHoverOut}>*/}
              <span data-player={position} className={spanClassName.build()}>{nom} {prenom[0]}.</span>
            {/*</a>*/}
            {remplacementJoueur && (
              <span>
                {remplacementJoueur.joueur2 && remplacementJoueur.joueur2.displayName}
                &nbsp;({remplacementJoueur.minutes}&apos;)
              </span>
            )}
          </p>
        </li>
      );
    });
  };

  _renderTitulaire = (
      playerList: RencontreJoueurType[],
      isLocalTeam?: boolean = true
    ): React$Element<'ol'>[] | null => {

    if (!playerList || playerList.length === 0) {
      return null;
    }

    const joueursColumn = chunk(
      playerList.filter((joueur) => joueur.estStarter).sort((a, b) => a.position - b.position),
      8
    );

    return joueursColumn.map((joueurs, index: number) => {
      const className = dynamicClassName('');

      if (index === 0) {
        className.add('mt-2');
      } else {
        className.add('mt-0 mt-md-2');
      }

      return (
        <ol key={joueurs[0].id} className={className.build()}>
          {this._renderColumn(joueurs, isLocalTeam)}
        </ol>
      );
    });
  };

  _renderRemplacant = (
      playerList: RencontreJoueurType[],
      chunkNb: number = 5,
      isLocalTeam?: boolean = true
    ): React$Element<'ol'>[] | null => {

    if (!playerList || playerList.length === 0) {
      return null;
    }

    const joueursColumn = chunk(
      playerList.filter((joueur) => !joueur.estStarter).sort((a, b) => a.position - b.position),
      chunkNb
    );

    return joueursColumn.map((joueurs, index: number) => {
      const className = dynamicClassName('');

      if (index === 0) {
        className.add('mt-2');
      } else {
        className.add('mt-md-2');
      }

      return (
        <ol key={`${joueurs[0].id}_${index}`} className={className.build()}>
          {this._renderColumn(joueurs, isLocalTeam)}
        </ol>
      );
    });
  };

  _getPlayer = (position: number, isLocal?: boolean): { nom: string, captain: boolean, media: string } => {
    const { rencontre, placeholder } = this.props;

    if (!rencontre) {
      return { nom: '-', captain: false, media: placeholder };
    }
    
    let players = rencontre.localJoueurs;
    if (isLocal === false) {
      players = rencontre.visiteurJoueurs;
    }
    const foundPlayer = players.find((joueur) => joueur.position === position);

    return (foundPlayer && (
      { nom: `${foundPlayer.prenom[0]}. ${foundPlayer.nom}`, captain: foundPlayer.estCapitaine, media: placeholder }
    )) || { nom: '-', captain: false, media: placeholder };
  };

  _renderSchema = (isLocal: boolean) => {
    const player1 = this._getPlayer(1, isLocal);
    const player2 = this._getPlayer(2, isLocal);
    const player3 = this._getPlayer(3, isLocal);
    const player4 = this._getPlayer(4, isLocal);
    const player5 = this._getPlayer(5, isLocal);
    const player6 = this._getPlayer(6, isLocal);
    const player7 = this._getPlayer(8, isLocal); // inversion volontaire position joueur
    const player8 = this._getPlayer(7, isLocal);
    const player9 = this._getPlayer(9, isLocal);
    const player10 = this._getPlayer(10, isLocal);
    const player11 = this._getPlayer(11, isLocal);
    const player12 = this._getPlayer(12, isLocal);
    const player13 = this._getPlayer(13, isLocal);
    const player14 = this._getPlayer(14, isLocal);
    const player15 = this._getPlayer(15, isLocal);

    return (
      <div className="schema">
        <div className="schema__firstLine">
          <div className="schema__player">
            <span>1</span>
            <p className={`${player1.captain ? 'captain' : ''}`}>{player1.nom}</p>
          </div>
          <div className="schema__player">
            <span>2</span>
            <p className={`${player2.captain ? 'captain' : ''}`}>{player2.nom}</p>
          </div>
          <div className="schema__player">
            <span>3</span>
            <p className={`${player3.captain ? 'captain' : ''}`}>{player3.nom}</p>
          </div>
        </div>
        <div className="schema__twoPlayer">
          <div className="schema__player">
            <span>4</span>
            <p className={`${player4.captain ? 'captain' : ''}`}>{player4.nom}</p>
          </div>
          <div className="schema__player">
            <span>5</span>
            <p className={`${player5.captain ? 'captain' : ''}`}>{player5.nom}</p>
          </div>
        </div>
        <div className="schema__thirdLine">
          <div className="schema__player">
            <span>6</span>
            <p className={`${player6.captain ? 'captain' : ''}`}>{player6.nom}</p>
          </div>
          <div className="schema__player">
            <span>8</span>
            <p className={`${player7.captain ? 'captain' : ''}`}>{player7.nom}</p>
          </div>
          <div className="schema__player">
            <span>7</span>
            <p className={`${player8.captain ? 'captain' : ''}`}>{player8.nom}</p>
          </div>
        </div>
        <div className="schema__twoPlayer schema__twoPlayer--second">
          <div className="schema__player">
            <span>9</span>
            <p className={`${player9.captain ? 'captain' : ''}`}>{player9.nom}</p>
          </div>
          <div className="schema__player">
            <span>10</span>
            <p className={`${player10.captain ? 'captain' : ''}`}>{player10.nom}</p>
          </div>
        </div>
        <div className="schema__backLine">
          <div className="schema__player">
            <span>11</span>
            <p className={`${player11.captain ? 'captain' : ''}`}>{player11.nom}</p>
          </div>
          <div className="schema__player">
            <span>12</span>
            <p className={`${player12.captain ? 'captain' : ''}`}>{player12.nom}</p>
          </div>
          <div className="schema__player">
            <span>13</span>
            <p className={`${player13.captain ? 'captain' : ''}`}>{player13.nom}</p>
          </div>
          <div className="schema__player">
            <span>14</span>
            <p className={`${player14.captain ? 'captain' : ''}`}>{player14.nom}</p>
          </div>
        </div>
        <div className="schema__oneLine">
          <div className="schema__player">
            <span>15</span>
            <p className={`${player15.captain ? 'captain' : ''}`}>{player15.nom}</p>
          </div>
        </div>
      </div>
    );
  };

  _renderVisiteurTeam = (visiteurs: any, visiteurStructure: any) => {
    const { open } = this.state;
    const { rencontre } = this.props;

    if (!open || !rencontre) {
      return null;
    }

    return (
      <div className="js-customDropdown-content row">
        <div className="col">
          <h3 className="mb-3">Composition de {(visiteurStructure && visiteurStructure.nom) || ''}</h3>
        </div>
        <div className="composition__team col col-lg-5">
          <div className="team">
            <div className="team__header">
              <i className="icon icon-shirt"/>
              <span className="ft-h4">Titulaires</span>
            </div>
            <div className="team__body">
              {this._renderTitulaire(visiteurs, false)}
            </div>
          </div>
        </div>
        <div className="composition__team col col-lg-5 mt-4 mt-lg-0">
          <div className="team">
            <div className="team__header">
              <i className="icon icon-substitution"/>
              <span className="ft-h4">Remplaçants</span>
            </div>
            <div className="team__body">
              {this._renderRemplacant(visiteurs, 8, false)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  _renderVisiteurTeamButton = () => {
    const { open } = this.state;
    const iconClassName = dynamicClassName('icon');
    const divClassName = dynamicClassName('box box--white ft-center');

    if (open) {
      iconClassName.add('icon-less');
      divClassName.add('mt-5 js-customDropdown-buttonClose');
    } else {
      iconClassName.add('icon-plus');
      divClassName.add('js-customDropdown-buttonOpen');
    }

    return (
      <div className={divClassName.build()}>
        <a // eslint-disable-line
          onClick={() => this.setState((prevState) => ({ open: !prevState.open }))}
          className="link-chevron link-chevron--pagination link-chevron link-chevron--inline"
        >
          <span>{`${open ? 'Fermer' : 'Voir'}`} la composition de l&apos;équipe adverse</span>
          <i className={iconClassName.build()} />
        </a>
      </div>
    );
  };

  renderHoverCards = (isLocal: boolean) => {
    // const { joueurs } = this.props;
    const { position, isPlayerHovered, playerHovered } = this.state;
    if (Object.keys(position).length > 0 && playerHovered !== '') {
      const positionCard = {
        position: "fixed",
        left: (position.left - 100) < 0 ? 5 : (position.left - 100),
        right: position.right - 100,
        top : position.top -100,
        bottom: position.bottom - 100
      };

      const { nom, media } = this._getPlayer(parseInt(playerHovered, 10), isLocal);
      return (
        <div key={`hoverCardPlayer${ nom}`}
          className={isPlayerHovered ? "composition__hoverCard active" : "composition__hoverCard"}
          style={positionCard}>
          <div className="hoverCard__portrait"
            style={{ backgroundImage: `url(${media})`, backgroundPosition: 'center' }}>
          </div>
          <div className="hoverCard__desc">
            <h5 className="ft-h5">{nom}</h5>
            {/* @TODO : plug player postiion when available <h6 className="ft-h6 ft-up">{poste}</h6> */}
          </div>
        </div>
      );
    };
    return null;
  };

  render() {
    const { rencontre } = this.props;

    if (!rencontre) {
      return null;
    }

    const { localJoueurs, visiteurJoueurs, visiteurStructure, localStructure } = rencontre;

    let locaux = localJoueurs;
    let visiteurs = visiteurJoueurs;
    let visiteurs_structure = visiteurStructure;
    let isLocal = true;
    if (rencontre.resultVisiteur.ourClub) {
      locaux = visiteurJoueurs;
      visiteurs = localJoueurs;
      visiteurs_structure = localStructure;
      isLocal = false;
    }

    const positionPlayersLocal = locaux.filter((joueur) => joueur.position !== null);
    const positionPlayersVisiteur = visiteurs.filter((joueur) => joueur.position !== null);
    if (positionPlayersLocal && positionPlayersLocal.length < 5) {
      return null;
    }

    return (
      <>
        <div className="row mt-5">
          <div className="col col-lg-8on9">
            <h3 className="mb-3">Composition de l&apos;équipe</h3>
            <div className="composition mt-4">
              {this.renderHoverCards(isLocal)}
              <div className="row">
                <div className="composition__schema col col-lg-6">
                  {this._renderSchema(isLocal)}
                </div>
                <div className="composition__team col col-lg-6 mt-4 mt-lg-0">
                  <div className="team">
                    <div className="team__header">
                      <i className="icon icon-shirt"/>
                      <span className="ft-h4">Titulaires</span>
                    </div>
                    <div className="team__body">
                      {this._renderTitulaire(locaux)}
                    </div>
                    <div className="team__header mt-4">
                      <i className="icon icon-substitution"/>
                      <span className="ft-h4">Remplaçants</span>
                    </div>
                    <div className="team__body">
                      {this._renderRemplacant(locaux)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {positionPlayersVisiteur && positionPlayersVisiteur.length > 5 && (
          <div className="row">
            <div className="col col-lg-8on9">
              <div className="composition composition--ext customDropdown mt-4">
                {this._renderVisiteurTeam(visiteurs, visiteurs_structure)}
                {this._renderVisiteurTeamButton()}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default RencontreTeam;
